export const TextData = [
    {
        title:"Accurate",
        content: <h2>Accurate</h2>
    },
    {
        title:"Intelligent",
        content: <h2>Intelligent</h2>
    },
    {
        title:"Effective",
        content: 'Effective'
    }
]